export default "__VITE_ASSET__d41b0fa8__"